import React from 'react';
import { ThemeProvider as StyledProvider } from 'styled-components';
import { combinedTheme, themes } from '../../theme/theme';
import { ThemeContext } from './useTheme';
import useUnifyUserProfileStore from '../core/UserProfileStore';

export default function UnifyThemeProvider({
  children,
}: {
  children: JSX.Element | React.ReactNode;
}) {

  const {theme} = useUnifyUserProfileStore();
  const [styles, setStyles] = React.useState(combinedTheme);
  const [mode , setMode] = React.useState(false);
  const themeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  React.useEffect(() => {

    let isDarkMode = theme === 'dark';
    const useSystemTheme =  localStorage.getItem('use-system-theme') === 'yes';
    if(useSystemTheme){
     isDarkMode = themeMediaQuery?.matches ? true : false;
    }
    setStyles((style) => {
      const newStyle = { ...style };
      newStyle.carbon.color = isDarkMode
        ? themes.default.color.dark
        : themes.default.color.light;
      newStyle.darkMode = isDarkMode;
      document.body.style.backgroundColor = newStyle.carbon.color.element.backplane.backgroundColor;
      return newStyle;
    });

    setMode(isDarkMode);
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ darkMode: mode }}>
      <StyledProvider theme={styles}>{children}</StyledProvider>
    </ThemeContext.Provider>
  );
}
